import { Component, ElementRef, OnDestroy, OnInit, viewChild } from '@angular/core';
import { EXCLUDED_DEPARTMENTS } from '../../core/territory-search/territory-search';
import { SearchService } from '../../shared/services/search.service';
import { ApiService } from '../../shared/services/api/api.service';
import { Router } from '@angular/router';
import { DropdownItem } from '../../common-explain/components/ex-dropdown/ex-dropdown.component';
import { firstValueFrom } from 'rxjs';
import { FeatureModalSmartSearchComponent } from '../feature-modal-smart-search/feature-modal-smart-search.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

interface FeatureCard {
  image: string;
  title: string;
  subtitle: string;
  modalComponent?: any;
}

const features: FeatureCard[] = [
  {
    image: 'assets/images/feature-thumbnail-municipal-prompts.png',
    title: 'features.municipal-prompts.title',
    subtitle: 'features.municipal-prompts.subtitle',
  },
  {
    image: 'assets/images/feature-thumbnail-smart-search.svg',
    title: 'features.smart-search.title',
    subtitle: 'features.smart-search.subtitle',
    modalComponent: FeatureModalSmartSearchComponent,
  },
];

export interface Territory {
  name: string;
  code: number;
  kind: string;
}
@Component({
  selector: 'app-territory-search-page',
  templateUrl: './territory-search-page.component.html',
  styleUrls: ['./territory-search-page.component.scss'],
})
export class TerritorySearchPageComponent implements OnInit, OnDestroy {
  searchButton = viewChild('searchButton', { read: ElementRef });
  dropdownItems: DropdownItem[] = [];
  selectedUid = '';

  protected readonly features = features;

  constructor(
    protected apiService: ApiService,
    protected searchService: SearchService,
    protected modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit() {
    /** reset needed to avoid artifacts when comming back and forth from seach component */
    firstValueFrom(this.apiService.exStatistics.AccountInfoReplaySubject).then(accountInfo => {
      const territoriesList = accountInfo.territories.filter(t => !EXCLUDED_DEPARTMENTS.includes(t.code));
      this.dropdownItems = territoriesList.map(territory => ({
        label: `${territory.code} - ${territory.name}`,
        value: territory.kind + territory.code,
      }));
    });
    this.searchService.resetSearchServiceMaps();
  }

  ngOnDestroy() {
    /** reset needed to avoid artifacts when comming back and forth from seach component */
    this.searchService.resetSearchServiceMaps();
  }

  onSubmitTerritory() {
    if (this.selectedUid) {
      this.router.navigate([`/search/${this.selectedUid}/article`]).then();
    }
  }

  departmentChange(item: DropdownItem | null) {
    this.selectedUid = item?.value;
    const button = (this.searchButton()?.nativeElement as HTMLElement).querySelector('button');
    if (button) {
      button.onclick = () => this.onSubmitTerritory();
      setTimeout(() => button.focus());
    }
  }
}
